import styled from 'styled-components'

export const BlogCard = styled.section`
  display: flex;
  flex-direction: column;
  align-items: start;
  flex-shrink: 0;
  width: 553px;
  height: 100%;

  cursor: pointer;

  background-color: ${(props) => props.theme.colors.white};
  border-radius: 16px;
  box-shadow: 0px 16px 16px rgba(50, 50, 71, 0.12),
    0px 24px 32px rgba(50, 50, 71, 0.16);

  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(105%);
    z-index: 1000;
    box-shadow: 0px 16px 16px rgba(38, 38, 54, 0.26),
      0px 24px 32px rgba(36, 36, 49, 0.253);
  }

  .text-container {
    display: flex;
    flex-direction: column;
    gap: 20px;

    padding: 12px;
    width: 100%;
    height: 100%;
    position: relative;

    .title {
      font-weight: bold;
    }
    .author {
      margin-top: auto;
    }
  }

  .image-container {
    width: 100%;
    height: 136px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      position: relative !important;
      object-fit: cover;
      border-radius: 16px 16px 0 0;
    }
  }

  @media (max-width: 1200px) {
    width: 500px;
    max-height: 770px;
  }

  @media (max-width: 1100px) {
    width: 480px;
    height: 100%;
  }

  @media (max-width: 500px) {
    width: 100%;
    max-width: 380px;
    .text-container {
      max-height: fit-content;
    }
  }
  @media (max-width: 410px) {
    max-width: 290px;
  }
`

export const TagContainer = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`
